import { Box } from '@chakra-ui/react';
import { memo, useMemo } from 'react';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';
import PreviewImage from 'UiKit/preview-image';

import useGetTalkingPointList from 'Domain/brief-live/useGetTalkingPointList';
import useGetGiveawayList from 'Domain/brief-live/useGetGiveawayList';
import TableSkeleton from 'View/brief-live/component/skeleton/table';
import { useBriefLiveState } from 'View/brief-live/state';
import getTableList from 'View/brief-live/section/table/const';

import styles from './styles.module.css';

const Table = ({ t }) => {
  const { state, filterState, updateFilterState, updateState } = useBriefLiveState();
  const { selectedImagePreview, isOpenImagePreview } = state;

  const isTalkingPoint = state?.selectedTab === 'talkingPoint';
  const tableList = useMemo(() => getTableList({ selectedTab: state?.selectedTab, t }), [state?.selectedTab, t]);

  const { data: talkingPointData, isFetching: isFetchingTalkingPoint } = useGetTalkingPointList({
    queryParams: filterState,
    enabled: isTalkingPoint,
  });
  const { data: giveawayData, isFetching: isFetchingGiveaway } = useGetGiveawayList({
    queryParams: filterState,
    enabled: !isTalkingPoint,
  });

  const onChangePagination = (page) => updateFilterState({ page });
  const onChangeSort = (sort) => updateFilterState({ sort });

  const handleClosePreview = () =>
    updateState({
      isOpenImagePreview: false,
      selectedImagePreview: [],
      ...(state.imagePreviewPreviousModal ? { [state.imagePreviewPreviousModal]: true } : {}),
      imagePreviewPreviousModal: null,
    });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetchingTalkingPoint && !isFetchingGiveaway} fallback={<TableSkeleton selectedTab={state?.selectedTab} />}>
        <TableComponent
          tableName="table__reporting"
          onSort={onChangeSort}
          columns={tableList}
          dataSource={isTalkingPoint ? talkingPointData?.talkingPoints : giveawayData?.giveaways}
          isScrollable
          isDataExist={isTalkingPoint ? talkingPointData?.isDataExist : giveawayData?.isDataExist}
          sortingData={filterState?.sort}
          rowHeight={isTalkingPoint ? '64px' : 'fit-content'}
          verticalAlignBody="top"
          paddingBodyBox="0"
          maxTableHeight="calc(100vh - 362px)"
          maxTableBodyHeight="calc(100vh - 442px)"
          tableComponentHeight="calc(100vh - 286px)"
          pagination={{
            currentPage: filterState?.page,
            totalData: isTalkingPoint ? talkingPointData?.totalData : giveawayData?.totalData,
            onChange: onChangePagination,
            isLoading: isFetchingTalkingPoint || isFetchingGiveaway,
          }}
        />
      </Condition>
      <PreviewImage images={selectedImagePreview} isOpen={isOpenImagePreview} onClose={handleClosePreview} initialIndex={0} />
    </Box>
  );
};

export default memo(Table);
